import { BottomButton, BottomFooter, FormContainer } from './styles';
import { useTranslate } from '@tolgee/react';
import CheckboxGroup from './CheckboxGroup';
import { RegionCheckbox } from './RegionCheckbox';
import { AuthScopeHint } from './AuthScopeHint';
import { RightOutlined } from '@ant-design/icons';
import { Formik } from 'formik';
import FormField from 'components/FormField';
import { MercadoAuthFormValues } from '../hooks/useMercadoAuthShop';
import { useAuthorizationPolicy } from '../hooks/useAuthorizationPolicy';
import { authScopeDisabledRegions, authScopePlatformAllowed } from '../utils/authScope';

const regionOptions: General.UpperCaseRegion[] = [
  'BR',
  'MX',
  'AR',
  'CO',
  'CL',
  'BO',
  'CR',
  'DO',
  'EC',
  'GT',
  'HN',
  'NI',
  'PA',
  'PY',
  'PE',
  'SV',
  'UY',
  'VE',
];

interface MercadoShopTypeProps {
  onNext?: (values: MercadoAuthFormValues) => void;
  initialValues?: MercadoAuthFormValues;
}

export const MercadoShopType = (props: MercadoShopTypeProps) => {
  const { onNext, initialValues } = props;
  const { t } = useTranslate();
  const { policy } = useAuthorizationPolicy();
  const platformAllowed = authScopePlatformAllowed(policy, 'mercado');

  return (
    <Formik<MercadoAuthFormValues>
      initialValues={initialValues || {}}
      onSubmit={(values) => {
        onNext?.(values);
      }}
    >
      {({ values, setFieldValue, submitForm }) => {
        const disabledRegions = authScopeDisabledRegions(policy, 'mercado', regionOptions);
        const btnDisable =
          !values.shopType ||
          (values.shopType === 'LOCAL' && !values.region) ||
          !platformAllowed ||
          disabledRegions.includes(values.region as General.UpperCaseRegion);
        return (
          <FormContainer layout="vertical">
            <FormField label={t('authShop.请选择您要添加的店铺类型')} name="shopType" required>
              {({ field }) => (
                <CheckboxGroup
                  options={[
                    {
                      value: 'CROSS',
                      render: <>{t('ViewShops.CROSS')}</>,
                    },
                    {
                      value: 'LOCAL',
                      render: <>{t('ViewShops.LOCAL')}</>,
                    },
                  ]}
                  value={field.value}
                  onChange={(shopType) => {
                    setFieldValue('region', undefined);
                    field.onChange(shopType);
                  }}
                />
              )}
            </FormField>
            {values.shopType &&
              (values.shopType === 'LOCAL' ? (
                <FormField label={t('authShop.请选择店铺站点')} name="region" required>
                  {({ field }) => (
                    <>
                      {disabledRegions.length > 0 ? <AuthScopeHint /> : null}
                      <RegionCheckbox
                        options={regionOptions}
                        value={field.value}
                        onChange={field.onChange}
                        disabledOptions={disabledRegions}
                      />
                    </>
                  )}
                </FormField>
              ) : null)}
            <BottomFooter>
              <BottomButton disabled={btnDisable} size="large" type="primary" onClick={submitForm}>
                {t('authShop.下一步')}
                <RightOutlined />
              </BottomButton>
            </BottomFooter>
          </FormContainer>
        );
      }}
    </Formik>
  );
};
